import { IRoleCrudModalLang } from '../../../types/lang'

export const roleCrudModalLang: IRoleCrudModalLang = {
	role_crud_modal: {
		title_create: 'Create role_ru',
		title_edit: 'Edit role_ru',
		title_clone: 'Clone role from base role_ru',
		title_remove_single: 'Remove <span>role_ru</span>',
		title_remove_multiple: 'Remove <span>roles_ru</span>',
		title_remove_multiple_cnt: 'Remove <span>{{cnt}} selected role(s)_ru</span>',
		title_not_remove_multiple_cnt: 'Will NOT be removed <span>{{cnt}} selected role(s) (SYSTEM)_ru</span>',
		field_code_label: 'Code_ru',
		field_code_placeholder: 'Code_ru',
		field_name_label: 'Name_ru',
		field_name_placeholder: 'Name_ru',
		field_is_system_label: 'System_ru',
		field_is_buyer_label: 'Buyer_ru',
		field_in_group_label: 'In group_ru',
		field_in_group_placeholder: 'In group_ru',
		field_is_team_label: 'Is team_ru',
		field_is_team_placeholder: 'Is team_ru',
		field_team_report_label: 'Team Report_ru',
		field_team_report_placeholder: 'Team Report_ru',
		field_notes_label: 'Notes_ru',
		field_notes_placeholder: 'Notes_ru',
		msg_remove_confirm: 'Are you sure?_ru',
		btn_create: 'Create_ru',
		btn_update: 'Save_ru',
		btn_clone: 'Clone_ru',
		btn_remove: 'Remove_ru',
		btn_close: 'Close_ru'
	}
}